import {initMixpanel} from 'common/report/tracking-setup';
import {reporter} from 'common/report/error-reporting';

const mixpanel = initMixpanel(PROJECT_3_MIXPANEL_TOKEN);

export const enum TrackEvents {
  ViewSignupPage = `View signup`,
  ViewSignupPagePartTwo = `Signup Page 2 Opened`,
  ViewSignInPage = `Viewed login page`,
  ViewRequestAccessPage = `Viewed request access page`,
  ClickRequestAccess = `Clicked request access`,
  SubmitAccessRequest = `Submitted access request`,
  ViewStartupsApplyPage = `Viewed Startup Scholarship application`,
  ViewStartupsThankYou = `Viewed Startup Scholarship Thank You`,
  ViewForgotPasswordPage = `Viewed forgot password page`,
  ViewResetPasswordPage = `Viewed reset password page`,
  ViewSMSSetupPage = `[2FA] Viewed SMS Setup Page (FE)`,
  ViewSMSVerificationPage = `[2FA] Viewed SMS Verification Page (FE)`,
  StartupApplyToFreePlan = `Clicked Free plan link on Startup Scholarship application`,
  StartupApplyToPlanBuilder = `Clicked plan builder link on Startup Scholarship`,
  ClickSetPassword = `Clicked set password`,
  ClickContactSupport = `Clicked contact support`,
  ClickConnectButton = `Clicked Connect Button`,
  EmbedCodeInput = `Embed Code Input`,
  EmbedLoginClick = `Embed Login Click`,
}

export const enum TrackProperties {
  PageVersion = `Page Version`,
  IsInvited = `Is Invited`,
  IsLoggedIN = `Is Logged In`,
  ProjectID = `project_id`,
  RequestStage = `Request Stage`,
  NextURL = `Next url`,
  Email = `$email`,
  IneligibleReason = `Ineligible Reason`,
  Department = `Department`,
  ReferralPartner = `Referral Partner`,
  IsDemo = `Is Demo Project`,
  AccessInstructionsLink = `Access Instructions Link`,
  IsMagicLinkRegistration = `Is Magic Link Registration`,
}

export function track(eventName: TrackEvents, properties = {}): void {
  try {
    mixpanel.track(eventName, properties);
  } catch (err) {
    reporter.error(`tracking error`, err);
  }
}

export function registerProperties(properties) {
  try {
    mixpanel.register(properties);
  } catch (err) {
    reporter.error(`tracking error`, err);
  }
}
